export * from './load-dynamic-pricing-container.component';
